import { upperFirst } from '../../../lib/utilities';

export function upperCaseFirstAll(str) {
    return str.split(' ').map(x=> upperFirst(x)).join(' ');
}
